import { render, staticRenderFns } from "./WealthboxAppDetails.vue?vue&type=template&id=a322ffee&"
import script from "./WealthboxAppDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./WealthboxAppDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports